const appConstants = {
    responseMessages: {
        users: {
            loginSuccess: 'Login success',
            loginFailed: 'Login Failed',
            registrationSuccess: 'registrationSuccess',
            registrationFailed: 'registrationFailed',
        },
    },
};

export default appConstants;